import { render, staticRenderFns } from "./lojaPerfeitaCampaignSetupModal.vue?vue&type=template&id=d71cb81e&scoped=true&"
import script from "./lojaPerfeitaCampaignSetupModal.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaCampaignSetupModal.vue?vue&type=script&lang=js&"
import style0 from "./lojaPerfeitaCampaignSetupModal.vue?vue&type=style&index=0&id=d71cb81e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71cb81e",
  null
  
)

export default component.exports